import styled from 'styled-components';

export const NotDTCStepFeedbackContent = styled.div`
  & ~ div {
    > div:first-child {
      button {
        font-size: 14px;
        &:not(:first-child) {
          margin-left: 15px;
        }
      }
    }
  }
`;
